import { Button } from '@openai/apps-sdk-ui/components/Button';
import type { Channel, FollowUpSource, Task, User } from '../shared/types';

export function followUpSourceLabel(
  source: FollowUpSource,
  tasks: Task[],
  channels: Channel[],
  users: User[],
  userId: string,
) {
  if (source.kind === 'task') {
    const task = tasks.find((task) => task.id === source.id);
    return task ? `Task · ${task.title}` : null;
  }
  if (source.kind === 'channel') {
    const channel = channels.find((channel) => channel.id === source.id);
    return channel ? `Channel · #${channel.name}` : null;
  }
  const peer = users.find((user) => user.id === source.id);
  return peer
    ? peer.id === userId
      ? `Personal notes · ${peer.name} (you)`
      : `Person · ${peer.name}`
    : null;
}
export function FollowUpSourceLink({
  source,
  tasks,
  channels,
  users,
  userId,
  open,
}: {
  source: FollowUpSource | null;
  tasks: Task[];
  channels: Channel[];
  users: User[];
  userId: string;
  open: (source: FollowUpSource) => void;
}) {
  if (!source) return null;
  const label = followUpSourceLabel(source, tasks, channels, users, userId);
  return label ? (
    <Button
      className="followup-source-link"
      color="secondary"
      variant="ghost"
      size="sm"
      onClick={() => open(source)}
      aria-label={`Open linked ${label}`}
    >
      <span>{label}</span>
    </Button>
  ) : (
    <span className="followup-source-unavailable">
      Linked {source.kind === 'dm' ? 'person' : source.kind} unavailable · unlink or choose another
      source in details
    </span>
  );
}
